<template>
  <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center filters__selected mb-4 mb-lg-5">
    <div class="element-label">
      {{ I18n.t("search_page.artworks_tab.sorting.label") }}
    </div>
    <div class="d-flex flex-wrap">
      <div
        v-for="(button, index) in sortingButtons"
        class="mt-2 mt-lg-0 mr-1 mr-md-2 mr-lg-3"
        v-b-tooltip.hover.topright
        :id="`sortBtn${index}`"
      >
        <button
          type="button"
          name="button"
          @click="changeSortType(button.sortType)"
          class="btn btn__toggle"
          :class="{
            disabled: button.disabled,
            clicked: button.active,
          }"
          :disabled="button.disabled"
        >
          {{ I18n.t(`search_page.artworks_tab.sorting.select.${button.sortType}`) }}
        </button>
        <b-tooltip
          v-if="button.disabled"
          :target="`sortBtn${index}`"
        >
          {{ I18n.t('auctions_catalogs.premium_info') }}
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SORTING } from '../../../consts';

export default {
  name: 'ArtworksSortButtons',
  data() {
    return {
      sortingValue: this.$route.query.sort || SORTING.ARTWORKS.DEFAULT_VALUE,
      sortingPath: SORTING.ARTWORKS.PATH,
    };
  },
  computed: {
    ...mapGetters(['fullAccessToArchive']),
    sortingButtons() {
      return [
        {
          sortType: SORTING.ARTWORKS.VALUES.DATE_DESC,
          active: this.isActiveBtn(SORTING.ARTWORKS.VALUES.DATE_DESC),
          disabled: false,
        },
        {
          sortType: SORTING.ARTWORKS.VALUES.RELEVANCE,
          active: this.isActiveBtn(SORTING.ARTWORKS.VALUES.RELEVANCE),
          disabled: false,
        },
        {
          sortType: SORTING.ARTWORKS.VALUES.SELLING_PRICE_DESC,
          active: this.isActiveBtn(SORTING.ARTWORKS.VALUES.SELLING_PRICE_DESC),
          disabled: !this.fullAccessToArchive,
        },
        {
          sortType: SORTING.ARTWORKS.VALUES.UNIFIED_INITIAL_PRICE_DESC,
          active: this.isActiveBtn(SORTING.ARTWORKS.VALUES.UNIFIED_INITIAL_PRICE_DESC),
          disabled: !this.fullAccessToArchive,
        },
      ];
    },
  },
  methods: {
    ...mapActions(['getArtworksWhenSortingIsChanging']),
    changeSortType(val) {
      const value = (val === SORTING.ARTWORKS.VALUES.RELEVANCE) ? null : val;

      this.sortingValue = val;
      this.getArtworksWhenSortingIsChanging({
        path: this.sortingPath,
        value,
      });
    },
    isActiveBtn(sortType) {
      return this.sortingValue === sortType;
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/artworks_sort_buttons.vue?c7cc2ba6